module.exports = __webpack_public_path__ + "img/hr-tree-08-b-leaves.66de1cad.png";